// Shared Figma link check and guidance copy for every Aero Figma link input.
// Used by Aero's link inputs. The conversion, the sharing check and the notes under the field are
// shared with Figmafolio (utils/figmaPaste.js, utils/useFigmaLinkRows.js).
import { classifyFigmaLink } from './figmaPaste';

export const FIGMA_SHARE_HINT =
  "In Figma, set Share to 'Anyone with the link can view', then copy the prototype link (it has /proto/ in it).";
export const FIGMA_HELP_URL =
  'https://help.figma.com/hc/en-us/articles/360040531773-share-files-and-prototypes';
export const FIGMA_PASSWORD_HINT =
  'Want a gate in front of it? Password protection is in Settings, on Basic and up.';

// Returns { ok, message }. Empty is not ok but has no message (nothing to warn about yet).
// A design, file or branch link is ok: it is turned into a prototype link (convertPastedLink)
// when pasted, when the field is left, and again when it is saved.
export function checkFigmaLink(raw) {
  const kind = classifyFigmaLink(raw);
  if (kind === 'empty') return { ok: false, message: null };
  if (kind === 'not_figma') {
    return { ok: false, message: 'Paste a Figma prototype link (figma.com/proto/...).' };
  }
  if (kind === 'unsupported') {
    return {
      ok: false,
      message: "That isn't a prototype link. Sites need a prototype from a Figma Design file.",
    };
  }
  return { ok: true, message: null };
}
